import OrganizeRequestedFilesModal from './OrganizeRequestedFilesModal.component';

export default OrganizeRequestedFilesModal;